// src/pages/WritePost/index.jsx
import React, { useState } from 'react';
import { Layout, Form, Input, Button, Typography, message, Card, Select } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { useBlog } from '../../context/BlogContext';
import './index.css';

const { Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input;

const WritePost = ({ loggedInUser, onLogout }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { addPost, posts } = useBlog();
  
  const isEdit = !!id;
  const currentPost = isEdit ? posts.find(post => post.id === parseInt(id)) : null;

  // 如果是编辑模式，设置表单初始值
  React.useEffect(() => {
    if (isEdit && currentPost) {
      form.setFieldsValue({
        title: currentPost.title,
        excerpt: currentPost.excerpt,
        content: currentPost.content,
        category: currentPost.category
      });
    }
  }, [isEdit, currentPost, form]);

  const onFinish = (values) => {
    setLoading(true);
    
    try {
      if (isEdit) {
        // 编辑文章逻辑（需要在context中实现updatePost）
        message.success('文章更新成功！');
      } else {
        // 创建新文章
        const newPost = addPost({
          title: values.title,
          excerpt: values.excerpt,
          content: values.content,
          author: {
            id: loggedInUser.id,
            username: loggedInUser.username,
            name: loggedInUser.username
          },
          category: values.category || '默认分类',
          tags: values.tags || [],
          coverImage: `https://picsum.photos/800/400?random=${Date.now()}`
        });
        
        message.success('文章发表成功！');
        // 跳转到新文章页面
        navigate(`/post/${newPost.id}`);
      }
    } catch (error) {
      message.error(isEdit ? '文章更新失败' : '文章发表失败');
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('发表失败:', errorInfo);
    message.error('请检查表单内容');
  };

  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
      <Content className="blog-content writepost-content">
        <Card className="writepost-card">
          <Title level={2} style={{ textAlign: 'center', marginBottom: '30px' }}>
            {isEdit ? '编辑文章' : '撰写文章'}
          </Title>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            requiredMark={false}
          >
            <Form.Item
              label="文章标题"
              name="title"
              rules={[{ required: true, message: '请输入文章标题!' }]}
            >
              <Input placeholder="请输入文章标题" size="large" />
            </Form.Item>

            <Form.Item
              label="文章分类"
              name="category"
            >
              <Select
                placeholder="选择文章分类"
                options={[
                  { value: '编程入门', label: '编程入门' },
                  { value: '前端开发', label: '前端开发' },
                  { value: '后端开发', label: '后端开发' },
                  { value: '移动开发', label: '移动开发' },
                  { value: '数据库', label: '数据库' },
                  { value: '人工智能', label: '人工智能' }
                ]}
              />
            </Form.Item>

            <Form.Item
              label="文章摘要"
              name="excerpt"
              rules={[{ required: true, message: '请输入文章摘要!' }]}
            >
              <TextArea rows={3} placeholder="请输入文章摘要" />
            </Form.Item>

            <Form.Item
              label="文章内容"
              name="content"
              rules={[{ required: true, message: '请输入文章内容!' }]}
            >
              <TextArea rows={12} placeholder="请输入文章内容" />
            </Form.Item>

            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <Button onClick={() => form.resetFields()}>
                  重置
                </Button>
                <Button type="primary" htmlType="submit" loading={loading}>
                  {isEdit ? '更新文章' : '发表文章'}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Content>
      <AppFooter />
    </Layout>
  );
};

export default WritePost;